@let lock = lockService.lock();
<patron-modal
  [visible]="!!lock"
  title="Licença em uso em outro dispositivo"
  confirmButtonText="Usar aqui"
  cancelButtonText="Sair"
  [confirmButtonLoading]="takingOver"
  (confirm)="useHere()"
  (cancel)="logout()"
  [backdrop]="'static'"
  [closeButton]="false">
  <div class="d-flex gap-3 align-items-start">
    <i class="pi pi-lock text-warning" style="font-size: 2rem"></i>
    <div>
      <p class="mb-2">
        Sua licença {{ systemLabel }}está sendo usada
        @if (lock?.device_name) {
          em <strong>{{ lock?.device_name }}</strong
          >.
        } @else {
          em outro dispositivo.
        }
      </p>
      @if (lock?.message) {
        <p class="text-muted mb-2">{{ lock?.message }}</p>
      }
      <p class="mb-0 text-muted">
        Você não foi desconectado. Clique em <strong>Usar aqui</strong> para continuar neste
        dispositivo — a tela do outro será bloqueada.
      </p>
    </div>
  </div>
</patron-modal>
